import type { ShiftDetail } from '../types/shift';

type ShiftStatsProps = Pick<ShiftDetail, 'code' | 'startTime' | 'endTime' | 'color'>;

export function ShiftStats({ code, startTime, endTime, color }: ShiftStatsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      <div className="bg-card border border-border rounded-lg p-4">
        <div className="text-sm text-muted-foreground mb-1">Shift Code</div>
        <div className="text-2xl font-bold text-foreground">{code || '—'}</div>
      </div>
      <div className="bg-card border border-border rounded-lg p-4">
        <div className="text-sm text-muted-foreground mb-1">Start Time</div>
        <div className="text-2xl font-bold text-foreground">{startTime}</div>
      </div>
      <div className="bg-card border border-border rounded-lg p-4">
        <div className="text-sm text-muted-foreground mb-1">End Time</div>
        <div className="text-2xl font-bold text-foreground">{endTime}</div>
      </div>
      <div className="bg-card border border-border rounded-lg p-4">
        <div className="text-sm text-muted-foreground mb-1">Colour</div>
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded" style={{ backgroundColor: color }} />
          <span className="text-sm text-muted-foreground">{color}</span>
        </div>
      </div>
    </div>
  );
}
